import React from 'react'
import scriptLoader from 'react-async-script-loader'
import config from 'config'

const withRateScript = (WrappedComponent) => {
  const WithRateScript = (props) => {
    // eslint-disable-next-line react/prop-types
    const { isScriptLoaded, isScriptLoadSucceed, ...rest } = props

    return <WrappedComponent {...rest} isScriptLoaded={isScriptLoaded && isScriptLoadSucceed} />
  }

  WithRateScript.displayName = `${WrappedComponent.displayName}WithRateScript`
  return scriptLoader(config.ratesLibraryUrl)(WithRateScript)
}

export default withRateScript
